'use client';

import {
  VpButton,
  VpIcon,
} from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useProjectFollowContext } from '@/app/[locale]/(entity)/components/provider/ProjectFollowProvider';
import { Loader } from '@/app/components/Loader';

export const Follow = ({ inverse = false }: { inverse?: boolean }) => {
  const t = useTranslations('PROJECT.FOLLOW');
  const { isPending, toggle, followed } = useProjectFollowContext();

  return (
    <Loader loading={isPending}>
      <VpButton
        data-testid="project-follow"
        variant="secondary"
        endSlot={(
          <VpIcon
            name={followed ? 'check' : 'add'}
            size={16}
          />
        )}
        onClick={toggle}
        disabled={isPending}
        {...(inverse && {
          variantStyle: 'inverse',
          size: 'small',
        })}
      >
        {followed ? t('FOLLOWED') : t('FOLLOWED_UP')}
      </VpButton>
    </Loader>
  );
};
